var _rect, _g, _path, _path2, _path3, _path4, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2760_17684)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2760_17684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.830078,
    width: 32,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2760_17684)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.830078 0V8H32.8301V0H0.830078Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.830078 16V24H32.8301V16H0.830078Z",
    fill: "#4D8B1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.830078 7H-0.169922V8V16V17H0.830078H32.8301H33.8301V16V8V7H32.8301H0.830078Z",
    fill: "#E31C1C",
    stroke: "#F5FBFF",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8496 3.92953C20.0399 3.53934 20.5516 3.11325 21.3845 2.65126C21.4132 2.63538 21.4477 2.63447 21.4772 2.64882C21.5269 2.67311 21.5476 2.73315 21.5231 2.78281L12.8918 20.4796L12.4424 20.2604L20.0508 4.66082C19.7063 4.6047 19.6392 4.36094 19.8496 3.92953Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8012 3.92953C14.0116 4.36094 13.9446 4.6047 13.6 4.66082L21.2085 20.2604L20.7591 20.4796L12.1278 2.78281C12.1032 2.73315 12.1239 2.67311 12.1737 2.64882C12.2031 2.63447 12.2377 2.63538 12.2663 2.65126C13.0993 3.11325 13.6109 3.53934 13.8012 3.92953Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8301 20C17.8268 20 21.8301 16.4183 21.8301 12C21.8301 7.58172 17.8268 4 16.8301 4C15.8334 4 11.8301 7.58172 11.8301 12C11.8301 16.4183 15.8334 20 16.8301 20Z",
    fill: "#E31C1C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2760_17684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 4,
    width: 11,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8301 20C17.8268 20 21.8301 16.4183 21.8301 12C21.8301 7.58172 17.8268 4 16.8301 4C15.8334 4 11.8301 7.58172 11.8301 12C11.8301 16.4183 15.8334 20 16.8301 20Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2760_17684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33008 19C11.1961 19 14.3301 15.866 14.3301 12C14.3301 8.13401 11.1961 5 7.33008 5C3.46408 5 0.330078 8.13401 0.330078 12C0.330078 15.866 3.46408 19 7.33008 19Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3301 19C30.1961 19 33.3301 15.866 33.3301 12C33.3301 8.13401 30.1961 5 26.3301 5C22.4641 5 19.3301 8.13401 19.3301 12C19.3301 15.866 22.4641 19 26.3301 19Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0301 10.9303C17.4865 10.606 17.8301 9.19357 17.8301 7.5003C17.8301 5.80703 17.4865 4.3946 17.0301 4.07031V10.9303ZM16.5301 10.8401C16.1244 10.3941 15.8301 9.06747 15.8301 7.5003C15.8301 5.93313 16.1244 4.60652 16.5301 4.16053V10.8401ZM16.5301 13.1605V19.8401C16.1244 19.3941 15.8301 18.0675 15.8301 16.5003C15.8301 14.9331 16.1244 13.6065 16.5301 13.1605ZM17.0301 19.9303V13.0703C17.4865 13.3946 17.8301 14.807 17.8301 16.5003C17.8301 18.1936 17.4865 19.606 17.0301 19.9303Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8301 11C17.3824 11 17.8301 11.4477 17.8301 12C17.8301 12.5523 17.3824 13 16.8301 13C16.2778 13 15.8301 12.5523 15.8301 12C15.8301 11.4477 16.2778 11 16.8301 11Z",
    fill: "#F5FBFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2760_17684"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.830078,
    width: 32,
    height: 24,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKe);
export default __webpack_public_path__ + "static/media/KE.7d05a6d420a34a3be75b0c9e994c2998.svg";
export { ForwardRef as ReactComponent };